"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpfsStorage = void 0;
const __1 = require("../..");
class IpfsStorage {
    constructor(arcxLogger, googleStorage, ipfsCollection, scoreBucketNames, defaultChainId) {
        this.arcxLogger = arcxLogger;
        this.googleStorage = googleStorage;
        this.ipfsCollection = ipfsCollection;
        this.scoreBucketNames = scoreBucketNames;
        this.defaultChainId = defaultChainId;
        this.scoresFile = 'scores';
        this.signaturesFiles = 'signatures';
    }
    readIpfs(chainId, epoch) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const ipfs = (yield this.ipfsCollection[(0, __1.getNetworkGroup)(chainId)].findOne({
                    epoch,
                }));
                return ipfs;
            }
            catch (error) {
                this.arcxLogger.warning(`IpfsStorage::readIpfs => Could not find Ipfs for epoch ${epoch}: ${error}`);
            }
        });
    }
    createIpfs(newLeaves, currentSignatures, currentEpoch) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const futureEpoch = currentEpoch + 2;
                yield Promise.all([
                    // Upcoming on-chain scores are always in a future epoch
                    this.storeScoresToIpfs(newLeaves, futureEpoch),
                    // Signatures are always for current epoch that is now finished
                    this.storeSignaturesToIpfs(currentSignatures, currentEpoch),
                ]);
                const scoresPulblicUrl = yield this.getScoresPublicUrl(futureEpoch);
                const ipfs = new __1.Ipfs(futureEpoch, scoresPulblicUrl);
                yield this.storeIpfsInDatabase(ipfs);
            }
            catch (error) {
                this.arcxLogger.error(`IpfsStorage::createIpfs => ${error}`);
            }
        });
    }
    storeSignaturesToIpfs(currentSignatures, epoch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.googleStorage
                .bucket(this.getBucketName(this.defaultChainId))
                .file(`${this.signaturesFiles}_${epoch}.json`)
                .save(JSON.stringify(currentSignatures));
            this.arcxLogger.info(`IpfsStorage::storeSignaturesToIpfs => Stored ${currentSignatures.length} signatures at epoch ${epoch}`);
        });
    }
    storeScoresToIpfs(newLeaves, epoch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.googleStorage
                .bucket(this.getBucketName(this.defaultChainId))
                .file(`${this.scoresFile}_${epoch}.json`)
                .save(JSON.stringify(newLeaves));
            this.arcxLogger.info(`IpfsStorage::storeScoresToIpfs => Stored ${newLeaves.length} scores at epoch ${epoch}`);
        });
    }
    getScoresPublicUrl(epoch) {
        return __awaiter(this, void 0, void 0, function* () {
            const file = this.googleStorage
                .bucket(this.getBucketName(this.defaultChainId))
                .file(`${this.scoresFile}_${epoch}.json`);
            return file.publicUrl();
        });
    }
    storeIpfsInDatabase(newIpfs) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.ipfsCollection[(0, __1.getNetworkGroup)(this.defaultChainId)].insertOne(newIpfs);
        });
    }
    getBucketName(chainId) {
        return (0, __1.getNetworkGroup)(chainId) === 'testnets'
            ? this.scoreBucketNames.testnets
            : this.scoreBucketNames.prodnets;
    }
}
exports.IpfsStorage = IpfsStorage;
//# sourceMappingURL=IpfsStorage.js.map